import * as PIXI from "pixi.js";
import Layers from "../../../../../../../src/layers/Layers";
import { eventBus, EnumEventBus } from "../../EventBus";
import TestQuestionManager from "../../TestQuestionManager/TestQuestionManager";
import ShapeManager from "./ShapeManager";
import HintManager from "./HintManager/HintManager";
import TracingPaper from "../../../entities/TracingPaper/TracingPaper";
import CoordinatePanelManager from "./CoordinatePanelManager/CoordinatePanelManager";
import GridArea from "../../../../../../../src/entities/GridArea";
import QuestionFactory from "./QuestionFactory";
import generateRandomlyQuestion from "../../../services/RandomlyQuestionGenerator/RandomlyQuestionGenerator";
import rotateCoordinate from "../../../../../../../src/utils/coord/rotateCoordinate";
import { GridConfig } from "../../../../../../../src/types/Interface";
import { Question, QuestionTypes } from "../../../types/Interface";
import { QuestionMode } from "../../../types/Enum";


export default class QuestionManager extends PIXI.Container {
  private Layers = Layers.getInstance();
  private TestQuestionManager = TestQuestionManager.getInstance();
  private Question!: Question;
  private QuestionDesc = this.addChild(new PIXI.Text());
  private CoordinatePanel!: CoordinatePanelManager;
  private TracingPaper!: TracingPaper;
  private HintManager = new HintManager();
  private ShapeManager = new ShapeManager();
  private QuestionTypes: QuestionTypes = { TYPE1: true, TYPE2: true };
  private isTest: boolean = false;

  constructor(private GridConfig: GridConfig) {
    super();
    this.TracingPaper = new TracingPaper(this.GridConfig.cellSize);
    this.CoordinatePanel = new CoordinatePanelManager(this.GridConfig);

    QuestionFactory.addDescConfig(this.QuestionDesc, this.GridConfig);

    this.addToLayer();
    this.generateQuestion();

    eventBus.on(EnumEventBus.setActiveQuestionType, d => this.setQuestionTypes(d));
    eventBus.on(EnumEventBus.newQuestion, () => this.generateQuestion());
    eventBus.on(EnumEventBus.startTest, () => this.generateQuestion());
    eventBus.on(EnumEventBus.showTestQuestion, (i: number) => this.showTestQuestion(i));
    eventBus.on(EnumEventBus.setQuestMode, (v: QuestionMode) => {
      this.isTest = v == QuestionMode.test;
      this.TestQuestionManager.reset();
      this.generateQuestion(true);
    });
  }

  private addToLayer = () => this.Layers.Top.addChild(this);
  private setQuestionTypes = (d: QuestionTypes) => {
    this.QuestionTypes = d
  };
  private showTestQuestion(qIndex: number) {
    this.Question = this.TestQuestionManager.getQuestion(qIndex);
    this.setQuestion();
  }
  private generateQuestion(isEmpty: boolean = false) {
    this.Question = isEmpty ? QuestionFactory.getEmptyQuestion() : generateRandomlyQuestion(this.Question, this.QuestionTypes);
    this.setQuestion();
    !isEmpty && eventBus.emit(EnumEventBus.questionType, this.Question.qType);

    if (this.isTest && !isEmpty) {
      this.TestQuestionManager.addQuestion({ ... this.Question });
    }
  };
  setQuestion() {
    const pivotCoord = GridArea.getGlobalCoord(this.GridConfig, this.Question.pivotPoint);
    const shapeCoords = this.Question.shapePoints.map(c => GridArea.getGlobalCoord(this.GridConfig, c));
    const rotatedShapeCoords = this.Question.rotatedShapePoints.map(c => GridArea.getGlobalCoord(this.GridConfig, c));
    const centerCoord = GridArea.getGlobalCoord(this.GridConfig, this.Question.centerPoint);
    const rotatedCenterCoord = rotateCoordinate(centerCoord, pivotCoord, this.Question.rotation);
    this.TracingPaper.setShapeDetails(shapeCoords, pivotCoord, this.Question.rotation)
    this.HintManager.setHint(this.GridConfig, this.Question);
    this.ShapeManager.draw({
      shapeCoords, rotatedShapeCoords, centerCoord, rotatedCenterCoord, pivotCoord,
      rotation: this.Question.rotation,
      qType: this.Question.qType,
      origin: this.Question.origin
    });
    this.CoordinatePanel.draw(this.Question.origin);
    this.QuestionDesc.text = this.Question.desc;
  }
}